export enum WebStorageType {
  LOCAL_STORAGE,
  SESSION_STORAGE
}
